import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap font-serif font-semibold ring-offset-background transition-all duration-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground hover:opacity-90",
        destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        outline: "border border-mauve bg-transparent text-foreground hover:bg-mauve-light rounded-full",
        secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-mauve-dark underline-offset-4 hover:underline",
        // Watercolor floral elegant variants
        invitation: "bg-gradient-to-r from-dusty-rose to-mauve text-foreground tracking-[0.1em] uppercase hover:-translate-y-0.5 rounded-full",
        "invitation-outline": "border border-mauve bg-transparent text-foreground tracking-[0.1em] uppercase hover:bg-mauve-light rounded-full",
        sage: "bg-sage text-foreground tracking-[0.1em] uppercase hover:bg-sage-dark rounded-full",
        "sage-outline": "border border-sage bg-transparent text-foreground hover:bg-sage-light rounded-full",
        blush: "bg-blush text-foreground tracking-[0.1em] uppercase hover:bg-blush-deep rounded-full",
      },
      size: {
        default: "h-12 px-8 py-3 text-sm",
        sm: "h-10 px-6 text-xs",
        lg: "h-14 px-10 py-4 text-base",
        xl: "h-16 px-12 py-5 text-lg",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props}
    />
  )
})
Button.displayName = "Button"

export { Button, buttonVariants }
